// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const lopunny: PokeData = {
  "id": 428,
  "name": "lopunny",
  "height": 12,
  "weight": 333,
  "base_experience": 168,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "pound",
    "double-kick",
    "jump-kick",
    "headbutt",
    "double-edge",
    "agility",
    "quick-attack",
    "defense-curl",
    "swift",
    "high-jump-kick",
    "dizzy-punch",
    "splash",
    "mach-punch",
    "foresight",
    "endure",
    "charm",
    "return",
    "baton-pass",
    "mirror-coat",
    "flatter",
    "magic-coat",
    "bounce",
    "healing-wish",
    "close-combat",
    "double-hit",
    "entrainment",
    "after-you",
    "rototiller",
    "draining-kiss",
    "play-rough",
    "baby-doll-eyes"
  ],
  "moves": [
    "double-kick",
    "jump-kick",
    "headbutt",
    "agility",
    "quick-attack",
    "splash",
    "flatter",
    "healing-wish",
    "close-combat",
    "rototiller",
    "play-rough",
    "leer",
    "protect"
  ],
  "evolution_chain": {
    "id": 220,
    "item": null,
    "species": [
      {
        "name": "buneary",
        "order": 454,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "lopunny",
        "order": 455,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 427,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": 160,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 120,
    "speed": 162,
    "ability_power": 118
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
